const base_url = 'https://youtube.googleapis.com/youtube/v3/'
const key = process.env.REACT_APP_YOUTUBE_KEY
const id = process.env.REACT_APP_YOUTUBE_ID

const isArchivedLivestream = (video) => Boolean(video?.liveStreamingDetails?.actualStartTime)

const keepOneStreamPerTitle = (streams) => {
  const titles = new Set()

  return [...streams]
    .sort(
      (first, second) =>
        Date.parse(first.liveStreamingDetails.scheduledStartTime) -
        Date.parse(second.liveStreamingDetails.scheduledStartTime)
    )
    .filter((stream) => {
      const title = stream?.snippet?.title?.trim().toLocaleLowerCase()

      if (!title || titles.has(title)) return !title

      titles.add(title)
      return true
    })
}

const fetchJson = async (endpoint) => {
  const apiCall = await fetch(base_url + endpoint)
  const json = await apiCall.json()
  return json
}

const getVideoDetails = async (videoIds) => {
  if (!videoIds.length) return []

  const details = await fetchJson(
    'videos?key=' + key + '&id=' + videoIds.join(',') + '&part=snippet,liveStreamingDetails'
  )

  return details.items || []
}

export const getLatestUploads = async () => {
  const channelData = await fetchJson('channels?key=' + key + '&id=' + id + '&part=contentDetails')
  const uploadsPlaylistId = channelData.items?.[0]?.contentDetails?.relatedPlaylists?.uploads

  if (!uploadsPlaylistId) return []

  const uploads = await fetchJson(
    'playlistItems?key=' + key + '&playlistId=' + uploadsPlaylistId + '&part=snippet&maxResults=20'
  )

  const videoIds = (uploads.items || [])
    .map((item) => item?.snippet?.resourceId?.videoId)
    .filter(Boolean)

  const details = await getVideoDetails(videoIds)

  return details
    .filter((video) => video?.snippet?.liveBroadcastContent === 'none' && !isArchivedLivestream(video))
    .slice(0, 20)
    .map((video) => ({
      id: {
        videoId: video.id
      },
      snippet: video.snippet
    }))
}

export const getScheduledLiveStreams = async () => {
  const streams = await fetchJson(
    'search?key=' + key + '&channelId=' + id + '&part=snippet&type=video&maxResults=10&eventType=upcoming'
  )

  const uniqueVideoIds = [...new Set((streams.items || []).map((stream) => stream?.id?.videoId).filter(Boolean))]
  const details = await getVideoDetails(uniqueVideoIds)

  return keepOneStreamPerTitle(
    details.filter((stream) => stream?.liveStreamingDetails?.scheduledStartTime)
  )
}
